var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilledDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5007 20.916C21.5277 20.916 24.7923 16.9985 24.7923 12.166C24.7923 7.33352 21.5277 3.41602 17.5007 3.41602C13.4736 3.41602 10.209 7.33352 10.209 12.166C10.209 16.9985 13.4736 20.916 17.5007 20.916Z",
    fill: "#363849"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7926 28.3537C30.4801 25.7287 28.001 23.5412 24.7926 22.2287C23.9176 21.937 22.8968 21.937 22.1676 22.3745C20.7093 23.2495 19.251 23.687 17.501 23.687C15.751 23.687 14.2926 23.2495 12.8343 22.3745C12.1051 22.0828 11.0843 21.937 10.2093 22.3745C7.00097 23.687 4.5218 25.8745 3.2093 28.4995C2.18847 30.3953 3.79263 32.5828 5.98013 32.5828H29.0218C31.2093 32.5828 32.8135 30.3953 31.7926 28.3537Z",
    fill: "#363849"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledDriver);
export default __webpack_public_path__ + "static/media/filledDriver.55423fd4a89b10837b47af7054a9555f.svg";
export { ForwardRef as ReactComponent };